import React, { useContext, useEffect, useState } from "react";
import { useDataProvider } from "src/mtska-frontend-data-provider";
import { Box, Table } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { AppContext } from "src/mtska-frontend-app-scaffolding";

const WidgetFringeBenefitSimilar = ({ car }) => {
    const { t } = useTranslation();
    const { items, loadAll, loading } = useDataProvider('vehicles/fringebenefitcar/similar')
    const { userCapabilities } = useContext(AppContext)

    const [isDrawable, setIsDrawable] = useState(false);

    useEffect(() => {
        if (!car || !car.setup) return;

        const filterModel = {
            make: car?.setup?.make,
            model: car?.setup?.model,
            setup: car?.setup?.setup,
            engineDisplacement: car?.setup?.engineDisplacement ?? null,
            powerHP: car?.setup?.powerHP ?? null,
            fuelType: car?.setup?.fuelType ?? null
        }
        loadAll(filterModel).then(() => {
            setIsDrawable(true)
        });
    }, [car]);

    return (
        isDrawable && <Box className="form-element form-element-cost-widget col-12">
            {JSON.stringify(items)}
        </Box>
    );
}

export default WidgetFringeBenefitSimilar;